// removed by extract-text-webpack-plugin
module.exports = {"contact":"_57Ze8swkZWUJoiytEZW-7","lineBreak":"_2L3wNuK9jmEBmWMTm5jaha","email":"_1s-mXiKlWWnDKr0B8onhD8","link":"_2GdnABvd8icps63xEeH9qY","social":"_3wp7q9gyZ7LlwikvjQtINd"};


//////////////////
// WEBPACK FOOTER
// ./confidentiality/styles.module.css
// module id = 459
// module chunks = 0